import { render, staticRenderFns } from "./FooterComponentKT.vue?vue&type=template&id=62ba7974&"
import script from "./FooterComponentKT.vue?vue&type=script&lang=js&"
export * from "./FooterComponentKT.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponentKT.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports